(function(){
    angular
        .module('appback')
        .directive('ngProteinaorina', ngProteinaorina);

        ngProteinaorina.$inject = ['$timeout','ResultadosService'];
        function ngProteinaorina($timeout,ResultadosService){
            return {
	            require: 'ngModel',
              	//templateUrl: '/backend/web/app/resultados/operacionmat.html',
	            scope: {
                  //ngModel : '=',
                  subanalitica: '=',
                  item: '='
              	},
	            link: function(scope, element, attrs, ngModel) {
	            	$timeout(function(){
	            		console.log(ngModel.$viewValue);
	            		if(scope.subanalitica.codigo_alfa=='UPT'){
			            	if((!ngModel.$viewValue ||ngModel.$viewValue=='' || ngModel.$viewValue==0)){
			            		ResultadosService.getProteinaOrina(scope.item.peticion_id,function(data){
			            			if(data.resultado){
			            				ngModel.$setViewValue(data.resultado);
		                				ngModel.$render();
				            		}
					            });
			            	}
			            }

	            	})
	            	
			      /*ngModel.$formatters.push(function(value) {
	            	console.log("tocecimal2");
			      	    return value ? parseFloat(value).toFixed(2).toString().replace(',', '.') : null;
			      });*/
				}
        	}
        }
})();